export { DateSelectorConnected as DateSelector } from './container';
